const BUNDLE_VARIANT_CONFIG = {
  // Wave Hill Chair
  '51324473966887': {
    targetVariantId: '51324473934119',
    quantityMultiplier: 2,
    discountPercentage: 12,
    discountCode: 'WAVEHILLPAIR12',
  },
  '51324473999655': {
    targetVariantId: '51324473934119',
    quantityMultiplier: 4,
    discountPercentage: 16,
    discountCode: 'WAVEHILLFOUR16',
  },
  // Westport Chair
  '49995109531943': {
    targetVariantId: '49995109466407',
    quantityMultiplier: 2,
    discountPercentage: 14,
    discountCode: 'WESTPORTPAIR14',
  },
  '50018858271015': {
    targetVariantId: '49995109466407',
    quantityMultiplier: 4,
    discountPercentage: 18,
    discountCode: 'WESTPORTFOUR18',
  },
};

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const submittedVariantId = String(formData.get('id') || '');
        const bundleConfig = BUNDLE_VARIANT_CONFIG[submittedVariantId];
        let discountCodeToApply = '';

        if (bundleConfig) {
          const rawQuantity = Number.parseInt(formData.get('quantity') || '1', 10);
          const quantity = Number.isNaN(rawQuantity) ? 1 : rawQuantity;
          formData.set('id', bundleConfig.targetVariantId);
          formData.set('quantity', String(quantity * bundleConfig.quantityMultiplier));
          discountCodeToApply = bundleConfig.discountCode;
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: submittedVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              if (discountCodeToApply) {
                window.location = `/discount/${encodeURIComponent(discountCodeToApply)}?redirect=${encodeURIComponent(
                  window.routes.cart_url
                )}`;
                return;
              }
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: submittedVariantId,
                cartData: response,
              });
            this.error = false;

            if (discountCodeToApply) {
              window.location = `/discount/${encodeURIComponent(discountCodeToApply)}?redirect=${encodeURIComponent(
                window.routes.cart_url
              )}`;
              return;
            }

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
